import React, { useState } from 'react';
import styled from 'styled-components';

import ConfettiBackgroundSquare, { SquareSize, SquarePosition } from './ConfettiBackgroundSquare';

interface Props {
    numSquares: number;
    children: React.ReactNode;
    fixedHeight?: number;
}

interface SquareConfig {
    position: SquarePosition;
    size: SquareSize;
    rotation: number;
}

const StyledConfettiBackground = styled.div`
    position: relative;
`;

const Content = styled.div`
    position: relative;
    z-index: 2;
`;

const FULL_ROTATION_IN_DEGREES = 360;

export default function ConfettiBackground({ children, numSquares, fixedHeight }: Props) {
    function generateBackgroundSquarePropValues() {
        return [...Array(numSquares)].map(() => {
            return {
                size: getRandomSize(),
                position: calculateRandomPosition(),
                rotation: getRandomRotation(),
            };
        });
    }
    const [squareConfigs] = useState<SquareConfig[]>(generateBackgroundSquarePropValues);

    return (
        <StyledConfettiBackground>
            <Content>{children}</Content>
            {squareConfigs.map((config, i) => {
                return (
                    <ConfettiBackgroundSquare
                        key={i}
                        size={config.size}
                        position={config.position}
                        rotation={config.rotation}
                        fixedHeight={fixedHeight}
                    />
                );
            })}
        </StyledConfettiBackground>
    );
}

function getRandomInt(max: number): number {
    return Math.floor(Math.random() * Math.floor(max));
}

function getRandomSize(): SquareSize {
    const choices: SquareSize[] = ['small', 'medium', 'large', 'extra-large'];
    return choices[getRandomInt(4)];
}

function calculateRandomPosition(): SquarePosition {
    const x = Math.floor(Math.random() * 100);
    const y = Math.floor(Math.random() * 100);
    return {
        x,
        y,
    };
}

function getRandomRotation(): number {
    return Math.floor(Math.random() * FULL_ROTATION_IN_DEGREES);
}
